export const INVITATION_LIST_ITEM_DEFAULT_STATE = {
  resendLoading: false,
};

export const FETCH_INTERVENTION_REQUEST =
  'app/Dashboard/FETCH_INTERVENTION_REQUEST';
export const FETCH_INTERVENTION_SUCCESS =
  'app/Dashboard/FETCH_INTERVENTION_SUCCESS';
export const FETCH_INTERVENTION_ERROR =
  'app/Dashboard/FETCH_INTERVENTION_ERROR';

export const SEND_INTERVENTION_CSV_REQUEST =
  'app/Dashboard/SEND_INTERVENTION_CSV_REQUEST';
export const SEND_INTERVENTION_CSV_SUCCESS =
  'app/Dashboard/SEND_INTERVENTION_CSV_SUCCESS';
export const SEND_INTERVENTION_CSV_ERROR =
  'app/Dashboard/SEND_INTERVENTION_CSV_ERROR';

export const CREATE_INTERVENTION_REQUEST =
  'app/Dashboard/CREATE_INTERVENTION_REQUEST';
export const CREATE_INTERVENTION_SUCCESS =
  'app/Dashboard/CREATE_INTERVENTION_SUCCESS';
export const CREATE_INTERVENTION_ERROR =
  'app/Dashboard/CREATE_INTERVENTION_ERROR';

export const EDIT_INTERVENTION_REQUEST =
  'app/Dashboard/EDIT_INTERVENTION_REQUEST';
export const EDIT_INTERVENTION_SUCCESS =
  'app/Dashboard/EDIT_INTERVENTION_SUCCESS';
export const EDIT_INTERVENTION_ERROR = 'app/Dashboard/EDIT_INTERVENTION_ERROR';

export const COPY_SESSION_REQUEST = 'app/Dashboard/COPY_SESSION_REQUEST';
export const COPY_SESSION_SUCCESS = 'app/Dashboard/COPY_SESSION_SUCCESS';
export const COPY_SESSION_ERROR = 'app/Dashboard/COPY_SESSION_ERROR';

export const REORDER_SESSION_LIST = 'app/Dashboard/REORDER_SESSION_LIST';
export const REORDER_SESSION_LIST_SUCCESS =
  'app/Dashboard/REORDER_SESSION_LIST_SUCCESS';
export const REORDER_SESSION_LIST_ERROR =
  'app/Dashboard/REORDER_SESSION_LIST_ERROR';

export const UPDATE_SESSION_SETTINGS_REQUEST =
  'app/Dashboard/UPDATE_SESSION_SETTINGS_REQUEST';
export const UPDATE_SESSION_SETTINGS_SUCCESS =
  'app/Dashboard/UPDATE_SESSION_SETTINGS_SUCCESS';
export const UPDATE_SESSION_SETTINGS_ERROR =
  'app/Dashboard/UPDATE_SESSION_SETTINGS_ERROR';

export const CHANGE_CURRENT_SESSION =
  'app/containers/InterventionDetailsPage/CHANGE_CURRENT_SESSION';

export const ENABLE_USER_ACCESS_REQUEST =
  'app/Dashboard/ENABLE_USER_ACCESS_REQUEST';
export const ENABLE_USER_ACCESS_SUCCESS =
  'app/Dashboard/ENABLE_USER_ACCESS_SUCCESS';
export const ENABLE_USER_ACCESS_ERROR =
  'app/Dashboard/ENABLE_USER_ACCESS_ERROR';

export const FETCH_USERS_WITH_ACCESS_REQUEST =
  'app/Dashboard/FETCH_USERS_WITH_ACCESS_REQUEST';
export const FETCH_USERS_WITH_ACCESS_SUCCESS =
  'app/Dashboard/FETCH_USERS_WITH_ACCESS_SUCCESS';
export const FETCH_USERS_WITH_ACCESS_ERROR =
  'app/Dashboard/FETCH_USERS_WITH_ACCESS_ERROR';

export const REVOKE_USER_ACCESS_REQUEST =
  'app/Dashboard/REVOKE_USER_ACCESS_REQUEST';
export const REVOKE_USER_ACCESS_SUCCESS =
  'app/Dashboard/REVOKE_USER_ACCESS_SUCCESS';
export const REVOKE_USER_ACCESS_ERROR =
  'app/Dashboard/REVOKE_USER_ACCESS_ERROR';

// create session constants
export const CREATE_SESSION_REQUEST = 'app/CREATE_SESSION_REQUEST';
export const CREATE_SESSION_SUCCESS = 'app/CREATE_SESSION_SUCCESS';
export const CREATE_SESSION_ERROR = 'app/CREATE_SESSION_ERROR';

// intervention invitation
export const FETCH_INTERVENTION_INVITATIONS_REQUEST =
  'app/FETCH_INTERVENTION_INVITATIONS_REQUEST';
export const FETCH_INTERVENTION_INVITATIONS_SUCCESS =
  'app/FETCH_INTERVENTION_INVITATIONS_SUCCESS';
export const FETCH_INTERVENTION_INVITATIONS_ERROR =
  'app/FETCH_INTERVENTION_INVITATIONS_ERROR';

export const SEND_INTERVENTION_INVITATIONS_REQUEST =
  'app/SEND_INTERVENTION_INVITATIONS_REQUEST';
export const SEND_INTERVENTION_INVITATIONS_SUCCESS =
  'app/SEND_INTERVENTION_INVITATIONS_SUCCESS';
export const SEND_INTERVENTION_INVITATIONS_ERROR =
  'app/SEND_INTERVENTION_INVITATIONS_ERROR';

export const RESEND_INTERVENTION_INVITATION_REQUEST =
  'app/RESEND_INTERVENTION_INVITATION_REQUEST';
export const RESEND_INTERVENTION_INVITATION_SUCCESS =
  'app/RESEND_INTERVENTION_INVITATION_SUCCESS';
export const RESEND_INTERVENTION_INVITATION_ERROR =
  'app/RESEND_INTERVENTION_INVITATION_ERROR';

export const DELETE_SESSION_REQUEST = 'app/DELETE_SESSION_REQUEST';
export const DELETE_SESSION_SUCCESS = 'app/DELETE_SESSION_SUCCESS';
export const DELETE_SESSION_ERROR = 'app/DELETE_SESSION_ERROR';

export const UPDATE_ALL_SESSIONS_SCHEDULE_REQUEST =
  'app/UPDATE_ALL_SESSIONS_SCHEDULE_REQUEST';
export const UPDATE_ALL_SESSIONS_SCHEDULE_SUCCESS =
  'app/UPDATE_ALL_SESSIONS_SCHEDULE_SUCCESS';
export const UPDATE_ALL_SESSIONS_SCHEDULE_ERROR =
  'app/UPDATE_ALL_SESSIONS_SCHEDULE_ERROR';

export const EXTERNAL_COPY_SESSION_REQUEST =
  'app/Dashboard/EXTERNAL_COPY_SESSION_REQUEST';
export const EXTERNAL_COPY_SESSION_SUCCESS =
  'app/Dashboard/EXTERNAL_COPY_SESSION_SUCCESS';
export const EXTERNAL_COPY_SESSION_ERROR =
  'app/Dashboard/EXTERNAL_COPY_SESSION_ERROR';

export const ADD_INTERVENTION_LOGO_REQUEST =
  'app/Dashboard/ADD_INTERVENTION_LOGO_REQUEST';
export const ADD_INTERVENTION_LOGO_SUCCESS =
  'app/Dashboard/ADD_INTERVENTION_LOGO_SUCCESS';
export const ADD_INTERVENTION_LOGO_ERROR =
  'app/Dashboard/ADD_INTERVENTION_LOGO_ERROR';

export const DELETE_INTERVENTION_LOGO_REQUEST =
  'app/Dashboard/DELETE_INTERVENTION_LOGO_REQUEST';
export const DELETE_INTERVENTION_LOGO_SUCCESS =
  'app/Dashboard/DELETE_INTERVENTION_LOGO_SUCCESS';
export const DELETE_INTERVENTION_LOGO_ERROR =
  'app/Dashboard/DELETE_INTERVENTION_LOGO_ERROR';

export const UPDATE_INTERVENTION_LOGO_REQUEST =
  'app/Dashboard/UPDATE_INTERVENTION_LOGO_REQUEST';
export const UPDATE_INTERVENTION_LOGO_SUCCESS =
  'app/Dashboard/UPDATE_INTERVENTION_LOGO_SUCCESS';
export const UPDATE_INTERVENTION_LOGO_ERROR =
  'app/Dashboard/UPDATE_INTERVENTION_LOGO_ERROR';

export const TRANSLATE_INTERVENTION_REQUEST =
  'app/Dashboard/TRANSLATE_INTERVENTION_REQUEST';
export const TRANSLATE_INTERVENTION_SUCCESS =
  'app/Dashboard/TRANSLATE_INTERVENTION_SUCCESS';
export const TRANSLATE_INTERVENTION_ERROR =
  'app/Dashboard/TRANSLATE_INTERVENTION_ERROR';

export const ADD_INTERVENTION_ATTACHMENTS_ERROR =
  'app/Dashboard/ADD_INTERVENTION_ATTACHMENTS_ERROR';
export const ADD_INTERVENTION_ATTACHMENTS_REQUEST =
  'app/Dashboard/ADD_INTERVENTION_ATTACHMENTS_REQUEST';
export const ADD_INTERVENTION_ATTACHMENTS_SUCCESS =
  'app/Dashboard/ADD_INTERVENTION_ATTACHMENTS_SUCCESS';
export const DELETE_INTERVENTION_ATTACHMENT_REQUEST =
  'app/Dashboard/DELETE_INTERVENTION_ATTACHMENT_REQUEST';
export const DELETE_INTERVENTION_ATTACHMENT_SUCCESS =
  'app/Dashboard/DELETE_INTERVENTION_ATTACHMENT_SUCCESS';

export const GENERATE_CONVERSATIONS_TRANSCRIPT_REQUEST =
  'app/Dashboard/GENERATE_CONVERSATIONS_TRANSCRIPT_REQUEST';
export const GENERATE_CONVERSATIONS_TRANSCRIPT_SUCCESS =
  'app/Dashboard/GENERATE_CONVERSATIONS_TRANSCRIPT_SUCCESS';
export const GENERATE_CONVERSATIONS_TRANSCRIPT_ERROR =
  'app/Dashboard/GENERATE_CONVERSATIONS_TRANSCRIPT_ERROR';

export const UPDATE_INTERVENTION_CONVERSATIONS_TRANSCRIPT =
  'app/Dashboard/UPDATE_INTERVENTION_CONVERSATIONS_TRANSCRIPT';

export const EXPORT_INTERVENTION_REQUEST =
  'app/Dashboard/EXPORT_INTERVENTION_REQUEST';
export const EXPORT_INTERVENTION_SUCCESS =
  'app/Dashboard/EXPORT_INTERVENTION_SUCCESS';
export const EXPORT_INTERVENTION_ERROR =
  'app/Dashboard/EXPORT_INTERVENTION_ERROR';

export const CHANGE_INTERVENTION_NARRATOR_REQUEST =
  'app/Dashboard/CHANGE_INTERVENTION_NARRATOR_REQUEST';
export const CHANGE_INTERVENTION_NARRATOR_SUCCESS =
  'app/Dashboard/CHANGE_INTERVENTION_NARRATOR_SUCCESS';
export const CHANGE_INTERVENTION_NARRATOR_ERROR =
  'app/Dashboard/CHANGE_INTERVENTION_NARRATOR_ERROR';

export const EDIT_SHORT_LINKS_REQUEST =
  'app/Dashboard/EDIT_SHORT_LINKS_REQUEST';
export const EDIT_SHORT_LINKS_SUCCESS =
  'app/Dashboard/EDIT_SHORT_LINKS_SUCCESS';
export const EDIT_SHORT_LINKS_ERROR = 'app/Dashboard/EDIT_SHORT_LINKS_ERROR';

export const ADD_COLLABORATORS_REQUEST =
  'app/Dashboard/ADD_COLLABORATORS_REQUEST';
export const ADD_COLLABORATORS_SUCCESS =
  'app/Dashboard/ADD_COLLABORATORS_SUCCESS';
export const ADD_COLLABORATORS_ERROR = 'app/Dashboard/ADD_COLLABORATORS_ERROR';

export const FETCH_COLLABORATORS_REQUEST =
  'app/Dashboard/FETCH_COLLABORATORS_REQUEST';
export const FETCH_COLLABORATORS_SUCCESS =
  'app/Dashboard/FETCH_COLLABORATORS_SUCCESS';
export const FETCH_COLLABORATORS_ERROR =
  'app/Dashboard/FETCH_COLLABORATORS_ERROR';

export const CHANGE_COLLABORATOR_SETTING_REQUEST =
  'app/Dashboard/CHANGE_COLLABORATOR_SETTING_REQUEST';
export const CHANGE_COLLABORATOR_SETTING_SUCCESS =
  'app/Dashboard/CHANGE_COLLABORATOR_SETTING_SUCCESS';
export const CHANGE_COLLABORATOR_SETTING_ERROR =
  'app/Dashboard/CHANGE_COLLABORATOR_SETTING_ERROR';

export const REMOVE_COLLABORATOR_REQUEST =
  'app/Dashboard/REMOVE_COLLABORATOR_REQUEST';
export const REMOVE_COLLABORATOR_SUCCESS =
  'app/Dashboard/REMOVE_COLLABORATOR_SUCCESS';
export const REMOVE_COLLABORATOR_ERROR =
  'app/Dashboard/REMOVE_COLLABORATOR_ERROR';

export const FETCH_CURRENT_USER_COLLABORATOR_DATA_REQUEST =
  'app/Dashboard/FETCH_CURRENT_USER_COLLABORATOR_DATA_REQUEST';
export const FETCH_CURRENT_USER_COLLABORATOR_DATA_SUCCESS =
  'app/Dashboard/FETCH_CURRENT_USER_COLLABORATOR_DATA_SUCCESS';
export const FETCH_CURRENT_USER_COLLABORATOR_DATA_ERROR =
  'app/Dashboard/FETCH_CURRENT_USER_COLLABORATOR_DATA_ERROR';

export const SET_CURRENT_EDITOR = 'app/Dashboard/SET_CURRENT_EDITOR';
export const SET_STARTING_EDITING = 'app/Dashboard/SET_STARTING_EDITING';
export const SET_STOPPING_EDITING = 'app/Dashboard/SET_STOPPING_EDITING';
export const RESET_COLLABORATION_STATE =
  'app/Dashboard/RESET_COLLABORATION_STATE';

export const ON_COLLABORATOR_REMOVED_RECEIVE =
  'app/Dashboard/ON_COLLABORATOR_REMOVED_RECEIVE';
export const REFRESH_INTERVENTION_DATA =
  'app/Dashboard/REFRESH_INTERVENTION_DATA';

export const RESET_REDUCER = 'app/Dashboard/RESET_REDUCER';

export const CLEAR_INTERVENTION_DATA_REQUEST =
  'app/Dashboard/CLEAR_INTERVENTION_DATA_REQUEST';
export const CLEAR_INTERVENTION_DATA_SUCCESS =
  'app/Dashboard/CLEAR_INTERVENTION_DATA_SUCCESS';
export const CLEAR_INTERVENTION_DATA_ERROR =
  'app/Dashboard/CLEAR_INTERVENTION_DATA_ERROR';
export const ON_SENSITIVE_DATA_REMOVED_RECEIVED =
  'app/Dashboard/ON_SENSITIVE_DATA_REMOVED_RECEIVED';

export const CREATE_PREDEFINED_PARTICIPANT_REQUEST =
  'app/CREATE_PREDEFINED_PARTICIPANT_REQUEST';
export const CREATE_PREDEFINED_PARTICIPANT_SUCCESS =
  'app/CREATE_PREDEFINED_PARTICIPANT_SUCCESS';
export const CREATE_PREDEFINED_PARTICIPANT_ERROR =
  'app/CREATE_PREDEFINED_PARTICIPANT_ERROR';

export const FETCH_PREDEFINED_PARTICIPANTS_REQUEST =
  'app/FETCH_PREDEFINED_PARTICIPANTS_REQUEST';
export const FETCH_PREDEFINED_PARTICIPANTS_SUCCESS =
  'app/FETCH_PREDEFINED_PARTICIPANTS_SUCCESS';
export const FETCH_PREDEFINED_PARTICIPANTS_ERROR =
  'app/FETCH_PREDEFINED_PARTICIPANTS_ERROR';

export const UPDATE_PREDEFINED_PARTICIPANT_REQUEST =
  'app/UPDATE_PREDEFINED_PARTICIPANT_REQUEST';
export const UPDATE_PREDEFINED_PARTICIPANT_SUCCESS =
  'app/UPDATE_PREDEFINED_PARTICIPANT_SUCCESS';
export const UPDATE_PREDEFINED_PARTICIPANT_ERROR =
  'app/UPDATE_PREDEFINED_PARTICIPANT_ERROR';

export const DEACTIVATE_PREDEFINED_PARTICIPANT_REQUEST =
  'app/DEACTIVATE_PREDEFINED_PARTICIPANT_REQUEST';
export const DEACTIVATE_PREDEFINED_PARTICIPANT_SUCCESS =
  'app/DEACTIVATE_PREDEFINED_PARTICIPANT_SUCCESS';
export const DEACTIVATE_PREDEFINED_PARTICIPANT_ERROR =
  'app/DEACTIVATE_PREDEFINED_PARTICIPANT_ERROR';

export const ACTIVATE_PREDEFINED_PARTICIPANT_REQUEST =
  'app/ACTIVATE_PREDEFINED_PARTICIPANT_REQUEST';
export const ACTIVATE_PREDEFINED_PARTICIPANT_SUCCESS =
  'app/ACTIVATE_PREDEFINED_PARTICIPANT_SUCCESS';
export const ACTIVATE_PREDEFINED_PARTICIPANT_ERROR =
  'app/ACTIVATE_PREDEFINED_PARTICIPANT_ERROR';

export const SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_REQUEST =
  'app/SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_REQUEST';
export const SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_SUCCESS =
  'app/SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_SUCCESS';
export const SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_ERROR =
  'app/SEND_PREDEFINED_PARTICIPANT_SMS_INVITATION_ERROR';

export const SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_REQUEST =
  'app/SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_REQUEST';
export const SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_SUCCESS =
  'app/SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_SUCCESS';
export const SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_ERROR =
  'app/SEND_PREDEFINED_PARTICIPANT_EMAIL_INVITATION_ERROR';

export const BULK_CREATE_PREDEFINED_PARTICIPANTS_REQUEST =
  'app/BULK_CREATE_PREDEFINED_PARTICIPANTS_REQUEST';
export const BULK_CREATE_PREDEFINED_PARTICIPANTS_SUCCESS =
  'app/BULK_CREATE_PREDEFINED_PARTICIPANTS_SUCCESS';
export const BULK_CREATE_PREDEFINED_PARTICIPANTS_ERROR =
  'app/BULK_CREATE_PREDEFINED_PARTICIPANTS_ERROR';

export const UNASSIGN_TAG_REQUEST = 'app/Dashboard/UNASSIGN_TAG_REQUEST';
export const UNASSIGN_TAG_SUCCESS = 'app/Dashboard/UNASSIGN_TAG_SUCCESS';
export const UNASSIGN_TAG_ERROR = 'app/Dashboard/UNASSIGN_TAG_ERROR';

export const FULFILL_RA_SESSION_REQUEST =
  'app/Dashboard/FULFILL_RA_SESSION_REQUEST';
export const FULFILL_RA_SESSION_SUCCESS =
  'app/Dashboard/FULFILL_RA_SESSION_SUCCESS';
export const FULFILL_RA_SESSION_ERROR =
  'app/Dashboard/FULFILL_RA_SESSION_ERROR';

export const FETCH_RA_SESSION_QUESTION_GROUPS_REQUEST =
  'app/Dashboard/FETCH_RA_SESSION_QUESTION_GROUPS_REQUEST';
export const FETCH_RA_SESSION_QUESTION_GROUPS_SUCCESS =
  'app/Dashboard/FETCH_RA_SESSION_QUESTION_GROUPS_SUCCESS';
export const FETCH_RA_SESSION_QUESTION_GROUPS_ERROR =
  'app/Dashboard/FETCH_RA_SESSION_QUESTION_GROUPS_ERROR';
